import { render } from "./controlCenter.vue?vue&type=template&id=4ee978ee&scoped=true"
import script from "./controlCenter.vue?vue&type=script&lang=js"
export * from "./controlCenter.vue?vue&type=script&lang=js"

import "./controlCenter.vue?vue&type=style&index=0&id=4ee978ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee978ee"]])

export default __exports__